import {Textoutline} from "@k/js/textoutline";
import {CONTROLLER_EVENTNAMES} from "@k/global/GlobalEventnames";
import globalsObject from "@k/js/globalsObject";
import {EventVerteiler} from "@k/global/eventVerteiler";
export default {
    fontOutlineIncrease(currentTextElem) {
        Textoutline.init();
        currentTextElem.outlineWidthLevel = Textoutline.getNextHigherOutlineLevel(currentTextElem.outlineWidthLevel);
        // noinspection JSCheckFunctionSignatures
        const newOutlineWidth = Textoutline.getHeightInPixelsFromHeightInCMRespectingScaling(
            currentTextElem.id,
            currentTextElem.outlineWidthLevel, Textoutline.getEffectiveHeightCMForOutlineComputation(currentTextElem)
        );
        EventVerteiler.broadcast(
            CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY,
            {
                id: currentTextElem.id, changedProperties: {outlineWidth: newOutlineWidth}
            }
        );
    },
    fontOutlineDecrease(currentTextElem) {
        Textoutline.init();
        currentTextElem.outlineWidthLevel = Textoutline.getNextLowerOutlineLevel(currentTextElem.outlineWidthLevel);
        const textHeight = Textoutline.getEffectiveHeightCMForOutlineComputation(currentTextElem);
        const newOutlineWidthInPixel = Textoutline.getHeightInPixelsFromHeightInCMRespectingScaling(
            currentTextElem.id,
            currentTextElem.outlineWidthLevel, textHeight
        );
        EventVerteiler.broadcast(
            CONTROLLER_EVENTNAMES.CHANGESELOBWITHHISTORY,
            {
                id: currentTextElem.id, changedProperties: {outlineWidth: newOutlineWidthInPixel}
            }
        );
    },
    outlineThicknessChangeAllowed(currentTextElement) {
        Textoutline.init();
        if (currentTextElement === null || currentTextElement.outlineColorValue === "<none>") {
            return {up: false, down: false};
        }
        // noinspection JSCheckFunctionSignatures
        const textHeight = Textoutline.getEffectiveHeightCMForOutlineComputation(currentTextElement);
        // noinspection JSSuspiciousNameCombination
        const outlineWidthCM = globalsObject.owayoJSViewer.getHeightInCMFromHeightInPixelRespectingScaling(currentTextElement.id, currentTextElement.outlineWidth);

        return {
            up: !Textoutline.outlineLevelIsMaxOrBigger(textHeight, outlineWidthCM),
            down: !Textoutline.outlineLevelIsMinimalOrSmaller(textHeight, outlineWidthCM)
        };
    }
}